import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';

@Component({
  selector: 'reactivos',
  templateUrl: './reactivos.component.html',
  styleUrls: ['./reactivos.component.scss']
})
export class ReactivosComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit() {

  }

}
